import { MicOff, Mic, PhoneOff, MessageSquareText, Settings, Square } from "lucide-react";

const Btn = ({ label, onClick, children, disabled, danger, testid, active }) => (
  <button
    type="button"
    aria-label={label}
    title={label}
    onClick={onClick}
    disabled={disabled}
    data-testid={testid}
    className="inline-flex h-10 w-10 items-center justify-center rounded-full transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
    style={{
      background: danger
        ? "hsla(0,72%,55%,0.12)"
        : active
          ? "hsla(36,10%,9%,0.92)"
          : "hsla(0,0%,100%,0.7)",
      color: danger
        ? "hsl(0 65% 42%)"
        : active
          ? "hsl(43 45% 96%)"
          : "hsl(30 9% 30%)",
      border: `1px solid ${
        danger ? "hsla(0,55%,55%,0.25)" : "hsla(38,25%,80%,0.65)"
      }`,
    }}
  >
    {children}
  </button>
);

export default function SessionControls({
  muted,
  speaking,
  transcriptOpen,
  onMute,
  onStopSpeaking,
  onEnd,
  onToggleTranscript,
  onOpenSettings,
}) {
  return (
    <div
      data-testid="session-controls"
      className="flex items-center justify-between gap-2"
    >
      <div className="flex items-center gap-2">
        <Btn
          label={muted ? "Unmute microphone" : "Mute microphone"}
          onClick={onMute}
          testid="ctrl-mute"
          active={muted}
        >
          {muted ? <MicOff className="h-4 w-4" /> : <Mic className="h-4 w-4" />}
        </Btn>
        <Btn
          label="Stop God from speaking"
          onClick={onStopSpeaking}
          testid="ctrl-stop-speaking"
          disabled={!speaking}
        >
          <Square className="h-4 w-4" fill="currentColor" />
        </Btn>
      </div>
      <div className="flex items-center gap-2">
        <Btn
          label={transcriptOpen ? "Hide transcript" : "Show transcript"}
          onClick={onToggleTranscript}
          testid="ctrl-toggle-transcript"
          active={transcriptOpen}
        >
          <MessageSquareText className="h-4 w-4" />
        </Btn>
        <Btn
          label="Open settings"
          onClick={onOpenSettings}
          testid="ctrl-settings"
        >
          <Settings className="h-4 w-4" />
        </Btn>
        <Btn label="End call" onClick={onEnd} testid="ctrl-end" danger>
          <PhoneOff className="h-4 w-4" />
        </Btn>
      </div>
    </div>
  );
}
